import 'react-datepicker/dist/react-datepicker.css';
import { getYear, getMonth } from 'date-fns';

import { datePickerHeaderProps } from '../../types';
import * as calendarConstants from '../../utils/constants/calendar';

export const customCalendarHeader = ({
  date,
  decreaseMonth,
  decreaseYear,
  increaseMonth,
  increaseYear,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
  prevYearButtonDisabled,
  nextYearButtonDisabled,
}: datePickerHeaderProps) => (
  <div className="flex justify-center m-2.5">
    <button
      type="button"
      onClick={decreaseYear}
      disabled={prevYearButtonDisabled}
      className="mr-[5px]">
      {'<<'}
    </button>
    <button
      type="button"
      onClick={decreaseMonth}
      disabled={prevMonthButtonDisabled}
      className="mr-[5px]">
      {'<'}
    </button>
    <span className="mr-[5px]">
      {calendarConstants.months[getMonth(date)]}
    </span>
    <span className="mr-[10px]">{getYear(date)}</span>
    <button
      type="button"
      onClick={increaseMonth}
      disabled={nextMonthButtonDisabled}
      className="mr-[5px]">
      {'>'}
    </button>
    <button
      type="button"
      onClick={increaseYear}
      disabled={nextYearButtonDisabled}
      className="mr-[5px]">
      {'>>'}
    </button>
  </div>
);
